import type { ScoreRecord } from "@dailywars/core/db";

import { addUtcDays } from "#/lib/yearActivityGrid";
import type { CalendarMonthDay } from "#/server/game/archiveCalendarMonth";

export function scoresByMapIdFromRecords({
  records,
  mapIds,
}: {
  records: readonly ScoreRecord[];
  mapIds: readonly string[];
}): Record<string, number | null> {
  const scoreByMapId = new Map(records.map((record) => [record.mapId, record.score]));
  return Object.fromEntries(
    mapIds.map((mapId) => [mapId, scoreByMapId.get(mapId) ?? null] as const),
  );
}

export function scoresByMapIdFromRecordsMap(
  records: readonly ScoreRecord[],
): Record<string, number> {
  return Object.fromEntries(records.map((record) => [record.mapId, record.score] as const));
}

export function monthScoreQueryBounds(monthKey: string): {
  dateFrom: string;
  dateToExclusive: string;
} {
  const year = Number(monthKey.slice(0, 4));
  const month = Number(monthKey.slice(5, 7));
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const monthStart = `${monthKey}-01`;
  const monthEnd = `${monthKey}-${String(lastDay).padStart(2, "0")}`;
  return {
    dateFrom: monthStart,
    dateToExclusive: addUtcDays(monthEnd, 1),
  };
}

export function applyBestScoresToMonthDays({
  days,
  scoresByMapId,
}: {
  days: CalendarMonthDay[];
  scoresByMapId: Record<string, number>;
}): CalendarMonthDay[] {
  return days.map((day) => ({
    ...day,
    standard: { ...day.standard, bestDays: scoresByMapId[day.standard.mapId] ?? null },
    premium: { ...day.premium, bestDays: scoresByMapId[day.premium.mapId] ?? null },
  }));
}
